import { call, takeLatest, takeEvery, delay, select, put } from 'redux-saga/effects';

import * as api from '../../services';
import { displayNotification, checkOnline, getNotification } from '../notifications';
import { refreshSessions, createBookmarkSuccess, updateBookmarkSuccess } from '../files';
import { bookmarkCreated, bookmarkDeleted } from '../user-settings';
import {
  CREATE_BOOKMARK,
  UPDATE_BOOKMARK,
  DELETE_BOOKMARK_SUCCESS,
  DELETE_BOOKMARK,
  creatingBookMark,
} from './actions';

export function* doDeleteBookmark(action) {
  const { fileId, id } = action;
  const fileObject = yield select((state) => state.files.fileObjects[fileId]);

  try {
    yield call(api.deleteBookmark, fileId, id);
    yield put({ type: DELETE_BOOKMARK_SUCCESS, id });
    yield put(
      displayNotification(getNotification('deleteBookmark', 'success')(fileObject?.filename, id))
    );
    yield put(refreshSessions());
    yield put(bookmarkDeleted(fileId, id));
  } catch (error) {
    console.error('Unable to delete bookmark: ', error);
    yield call(checkOnline);
    yield put(
      displayNotification(getNotification('deleteBookmark', 'error')(fileObject?.filename, id))
    );
  }
}

export function* doCreateBookmark(action) {
  const { fileId, bookmark } = action;

  try {
    const fileObject = yield select((state) => state.files.fileObjects[fileId]);
    yield put(creatingBookMark(true));
    const response = yield call(api.createBookmark, fileId, bookmark);
    yield put(createBookmarkSuccess({ fileId, bookmark: response }));
    yield put(
      displayNotification(
        getNotification('createBookmark', 'success')(fileObject.filename, response.id)
      )
    );
    yield put(refreshSessions());
    yield put(bookmarkCreated(fileId, response));
    yield delay(3000);
    yield put(creatingBookMark(false));
  } catch (error) {
    console.error('Unable to create bookmark: ', error);
    yield call(checkOnline);
    yield put(displayNotification(getNotification('createBookmark', 'error')()));
  }
}

export function* doUpdateBookmark(action) {
  const { fileId, bookmarkId, bookmark } = action;

  try {
    const fileObject = yield select((state) => state.files.fileObjects[fileId]);
    yield put(creatingBookMark(true));
    const response = yield call(api.updateBookmark, fileId, bookmarkId, bookmark);
    yield put(updateBookmarkSuccess({ fileId, bookmarkId, bookmark: response }));
    yield put(
      displayNotification(
        getNotification('updateBookmark', 'success')(fileObject.filename, response.id)
      )
    );
    yield put(refreshSessions());
    yield delay(3000);
    yield put(creatingBookMark(false));
  } catch (error) {
    console.error('Unable to update bookmark: ', error);
    yield call(checkOnline);
    yield put(displayNotification(getNotification('updateBookmark', 'error')()));
  }
}

export const sagas = [
  takeLatest(CREATE_BOOKMARK, doCreateBookmark),
  takeLatest(UPDATE_BOOKMARK, doUpdateBookmark),
  takeEvery(DELETE_BOOKMARK, doDeleteBookmark),
];
